import { useEffect } from "react";
function DirectionSetter() {
  const { i18n } = require('react-i18next').useTranslation();
  useEffect(() => {
    document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
  }, [i18n.language]);
  return null;
}
import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import App from "./App"
import AdminDashboard from "./admin/AdminDashboard";
import "./index.css"
import "./i18n"

import { I18nextProvider } from "react-i18next"
import i18n from "./i18n"
import { AdminAuthProvider } from "./context/AdminAuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"))
import { Routes, Route } from "react-router-dom";

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <AdminAuthProvider>
        <DirectionSetter />
        <BrowserRouter>
          <Routes>
            <Route path="/admin/*" element={<AdminDashboard />} />
            <Route path="/*" element={<App />} />
          </Routes>
        </BrowserRouter>
      </AdminAuthProvider>
    </I18nextProvider>
  </React.StrictMode>
)